export const API_BASE_URL = process.env.NEXT_PUBLIC_API_BASE_URL || 'http://localhost:8000'

async function fetchJSON<T>(path: string, init?: RequestInit): Promise<T> {
  const res = await fetch(`${API_BASE_URL}${path}`, {
    ...init,
    headers: {
      'Content-Type': 'application/json',
      ...(init?.headers || {}),
    },
    next: { revalidate: 30 },
  })
  if (!res.ok) {
    throw new Error(`API error ${res.status}`)
  }
  return (await res.json()) as T
}

type ApiClient = {
  getSchedule<T = unknown>(): Promise<T>
  getStandings<T = unknown>(): Promise<T>
  getSponsors<T = unknown>(): Promise<T>
  submitTeamInterest(body: unknown): Promise<unknown>
  submitSponsorInterest(body: unknown): Promise<unknown>
  submitSupportTicket(body: { name: string; email: string; category: string; description: string }): Promise<unknown>
}

export const api: ApiClient = {
  getSchedule: <T = unknown>() => fetchJSON<T>('/public/schedule'),
  getStandings: <T = unknown>() => fetchJSON<T>('/public/standings'),
  getSponsors: <T = unknown>() => fetchJSON<T>('/public/sponsors'),
  submitTeamInterest: body =>
    fetchJSON('/public/team-interest', { method: 'POST', body: JSON.stringify(body) }),
  submitSponsorInterest: body =>
    fetchJSON('/public/sponsor-interest', { method: 'POST', body: JSON.stringify(body) }),
  submitSupportTicket: body =>
    fetchJSON('/public/support-ticket', { method: 'POST', body: JSON.stringify(body) }),
}
